<template>
  <section>
    <div class="banner-2-bg pt-50 pb-50">
      <div class="ta-center analytics-header">
        {{ $t("landingPage.analytics.head") }}
      </div>

      <ul class="list-inline counter-wrap">
        <li class="list-inline-item">
          <div class="single-counter text-center">
            <span>{{ $t("landingPage.analytics.row1.count") }}</span>
            <h6>{{ $t("landingPage.analytics.row1.text") }}</h6>
          </div>
        </li>
        <li class="list-inline-item">
          <div class="single-counter text-center">
            <span>{{ $t("landingPage.analytics.row2.count") }}</span>
            <h6>{{ $t("landingPage.analytics.row2.text") }}</h6>
          </div>
        </li>
        <li class="list-inline-item">
          <div class="single-counter text-center">
            <span>{{ $t("landingPage.analytics.row3.count") }}</span>
            <h6>{{ $t("landingPage.analytics.row3.text") }}</h6>
          </div>
        </li>
      </ul>
    </div>
  </section>
  <!--------------------------->
</template>
<script>
import { setLocale } from "../services/firebase";
export default {
  name: "Analytics",
  mounted() {
    setLocale();
  },
};
</script>
